import { render, staticRenderFns } from "./about_m.vue?vue&type=template&id=6e76ecfc&scoped=true&"
import script from "./about_m.vue?vue&type=script&lang=js&"
export * from "./about_m.vue?vue&type=script&lang=js&"
import style0 from "./about_m.vue?vue&type=style&index=0&id=6e76ecfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e76ecfc",
  null
  
)

export default component.exports